import type { ServiceResponse } from "../api.types";
import { privateAPI } from "../axios";
import type { LeadSource } from "./leadSources.types";

export const getLeadSources = async () => {
  const { data } =
    await privateAPI.get<ServiceResponse<LeadSource[]>>(`/lead-sources`);

  return data.data;
};
